import ManagePayments from './ManagePayments'
export default ManagePayments
